import React from 'react'
import { observer } from 'mobx-react'
import TagManager from 'react-gtm-module'
import {
  accountsContainer,
  accountsAddressContainer,
  customerContainer,
} from 'src/models'
import B2BAccountProfileForm from './B2BAccountProfileForm'
import { pageNames } from 'src/routes/pathParams'
import { i18nTranslate, setStoragesForAccountConversion } from 'src/utils'
import { MetaDecorator } from 'src/views/components'

@observer
class B2BAccountProfile extends React.Component {
  componentDidMount() {
    this.setGTMDetails()
    setStoragesForAccountConversion()
  }

  setGTMDetails = () => {
    const userDetails = customerContainer.profileResponse || {}
    const addresses = accountsContainer.profileResponse?.addresses || ''
    const { b2bAccountProfile } = pageNames

    /**
     * @info
     * GTM Datalayer -  Send event when user initially loads/visits My Account Profile page.
     */
    TagManager.dataLayer({
      dataLayer: {
        event: 'NuskinProfileAccount',
        pagePath: b2bAccountProfile,
        pageTitle: 'My Account Profile',
        userDetails: {
          userId: userDetails?.id || '',
          email: userDetails?.email || '',
          firstName: userDetails?.firstName || '',
          lastName: userDetails?.lastName || '',
        },
        addresses,
        platform: 'equinox',
      },
    })
  }

  updateAccountAddress = async (formData = {}, addressInfo) => {
    if (addressInfo?.addressId || addressInfo?.id) {
      await accountsAddressContainer.updateAddress(formData, addressInfo)
    } else {
      await accountsAddressContainer.addAddress({
        setDefaultAddress: true,
        ...formData,
      })
    }
  }
  updateAccountInfo = formData => {
    accountsContainer.updateAccountInfo(formData)
  }

  getAccountAttributes = () => {
    const accountAttributes = []
    const attributes =
      accountsContainer.accountAttributesWithoutSize?.attributes || []
    const properties = accountsContainer.profileResponse?.properties || []

    attributes.map((attributesList = {}) => {
      properties.map((propertiesList = {}) => {
        if (
          propertiesList.attributeId === attributesList.identifier &&
          attributesList.required === true &&
          attributesList.status.toLowerCase() === 'active'
        ) {
          const { validation, fieldtype, required, name, status, identifier } =
            attributesList
          accountAttributes.push({
            ...propertiesList,
            fieldtype,
            required,
            validation,
            status,
            name,
            // sequence: attributesList.sequence,
            // defaultValue: propertiesList.value,
            identifier,
            value: propertiesList.value,
          })
        }
      })
    })
    return accountAttributes
  }

  getDataModal() {
    return {
      email: customerContainer.profileResponse?.email || '',
      addressData: accountsContainer.profileResponse || {},
      accountSettings: accountsContainer.accountSettings || {},
      accountAttributes: this.getAccountAttributes() || [],
      myAccountB2BAccountProfileTitle: i18nTranslate(
        'myAccountB2BAccountProfilePage.title',
        'My Account Profile | Nu Skin'
      ),
      description: 'B2B Account Profile Page',
    }
  }

  render() {
    const data = this.getDataModal()
    return (
      <>
        <MetaDecorator
          title={data?.myAccountB2BAccountProfileTitle}
          imageUrl=""
          imageAlt=""
          description={data?.description}
          location={this.props}
        />
        {data && (
          <B2BAccountProfileForm
            isSelfOnBoard={false}
            accountAttributes={data?.accountAttributes}
            buyerAdminMailId={data?.email}
            accountSettings={data?.accountSettings}
            prefillData={data?.addressData}
            updateAccountInfo={this.updateAccountInfo}
            updateAccountAttributeInfo={this.updateAccountAttributeInfo}
            updateAccountAddress={this.updateAccountAddress}
            history={this.props?.history}
          />
        )}
      </>
    )
  }
}

export { B2BAccountProfile }
// export default B2BAccountProfile
export default B2BAccountProfile
